import React from 'react';
import { Switch, Route, Redirect } from 'react-router';
import { PrivateRoute } from './components';
import CaseStatusHistory from './../../containers/case-status-history';
import CaseStatusesHistory from './../../containers/case-statuses-history';
import Contexts from './../../containers/contexts';
import Home from './../../containers/home';
import Logs from './../../containers/logs';
import OAuth from './../../containers/oauth';
import Organization from './../../containers/organization';
import Widget from './../../containers/widget';

const Routes = () =>
    <Switch>
        <Route
            component={Home}
            exact
            path="/" />
        <PrivateRoute
            component={CaseStatusesHistory}
            exact
            path="/historia-statusow-spraw" />
        <PrivateRoute
            component={CaseStatusHistory}
            path="/historia-statusow-spraw/:caseStatusId" />
        <PrivateRoute
            component={Contexts}
            path="/konteksty" />
        <PrivateRoute
            component={Logs}
            path="/logi" />
        <Route
            component={OAuth}
            exact
            path="/oauth" />
        <Route
            component={Widget}
            path="/widget" />
        <Route
            component={Organization}
            path="/jednostki/:organization" />
        <Redirect
            to="/" />
    </Switch>

export default Routes;


// WEBPACK FOOTER //
// ./src/components/routes/Routes.js